import { set } from "idb-keyval";
import LocalStorageKey from "types/enums/LocalStorageKey";

export default async function setLocalStorageProjectId(
  val: string
): Promise<void> {
  await set(LocalStorageKey.ProjectId, val);
}
